import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { Grid, Box, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { FormProvider, RHFTextField } from '../../components/hook-form';
import { networkCreateGameJoinPlaylist, networkUpdateGameJoinPlaylist } from 'src/network/gameJoin';
import { GeneralUpload } from 'src/components/general';
import { useQueryClient } from '@tanstack/react-query';
import { GAME_JOIN_PLAYLIST_LIST } from 'src/constants/queryKeys';
import { getDefaultValues } from './defualtValues';
import { schema } from './validationSchema';
import useFormsModalStore from 'src/store/forms';

// ----------------------------------------------------------------------

export default function GamePlayListForm() {
  const { modal, closeModal } = useFormsModalStore();
  const queryClient = useQueryClient();

  const { enqueueSnackbar } = useSnackbar();

  const gamePlaylistDetails = modal?.data;
  const isEditMode = !!gamePlaylistDetails;

  // ----------------------------------------------------------------------

  const defaultValues = getDefaultValues(gamePlaylistDetails);

  const methods = useForm({
    // resolver: yupResolver(schema), // todo schema
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
    setValue,
    trigger,
  } = methods;

  // ----------------------------------------------------------------------

  const onSubmit = async (values, event) => {
    const PAYLOAD = {
      ...values,
      GameJoinApplicationPlayListApplicationID: -1,
    };
    
    try {
      if (isEditMode) {
        const res = await networkUpdateGameJoinPlaylist(gamePlaylistDetails?.GameJoinApplicationPlayListID, PAYLOAD);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('پلی لیست موردنظر با موفقیت ویرایش شد');
          if (event.nativeEvent.submitter.name === 'save') {
            closeModal();
          }
          await queryClient.invalidateQueries({ queryKey: [GAME_JOIN_PLAYLIST_LIST] });
        } else {
          enqueueSnackbar('خطایی رخ داد !', { variant: 'error' });
        }
      } else {
        const res = await networkCreateGameJoinPlaylist(PAYLOAD);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('پلی لیست موردنظر با موفقیت ایجاد شد');
          if (event.nativeEvent.submitter.name === 'save') {
            closeModal();
          }
          await queryClient.invalidateQueries({ queryKey: [GAME_JOIN_PLAYLIST_LIST] });
        } else {
          enqueueSnackbar('خطایی رخ داد !', { variant: 'error' });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  // ----------------------------------------------------------

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box sx={{ p: 3 }}>
            <Box
              sx={{
                display: 'grid',
                columnGap: 2,
                rowGap: 3,
                gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
              }}
            >
              <RHFTextField name="GameJoinApplicationPlayListLabel" type="text" label="عنوان فهرست بسته محتوا" />
              <RHFTextField name="GameJoinApplicationPlayListSubTitle" type="text" label="زیر عنوان" />

              <GeneralUpload
                label="لوگو"
                id="game_join_application_play_list_logo"
                name="GameJoinApplicationPlayListLogo"
                afterChangeAction={(res) => {
                  setValue('GameJoinApplicationPlayListLogo', res);
                  trigger('GameJoinApplicationPlayListLogo');
                }}
              />

              <GeneralUpload
                label="پس زمینه"
                id="game_join_application_play_list_backdrop"
                name="GameJoinApplicationPlayListBackDrop"
                afterChangeAction={(res) => {
                  setValue('GameJoinApplicationPlayListBackDrop', res);
                  trigger('GameJoinApplicationPlayListBackDrop');
                }}
              />
            </Box>

            <Box
              sx={{
                mt: 3,
                display: 'grid',
                columnGap: 2,
                rowGap: 3,
                gridTemplateColumns: { xs: 'repeat(1, 1fr)' },
              }}
            >
              <RHFTextField name="GameJoinApplicationPlayListBody" multiline rows={6} label="توضیحات" />
            </Box>

            <div className="flex items-center gap-4 mt-6">
              <LoadingButton type="submit" variant="contained" name="save" loading={isSubmitting}>
                ذخیره
              </LoadingButton>
              <LoadingButton type="submit" variant="contained" color="info" name="saveAndContinue" loading={isSubmitting}>
                {isEditMode ? 'ذخیره و ادامه ویرایش' : 'ذخیره و ایجاد بعدی'}
              </LoadingButton>
              <Button onClick={closeModal} variant="contained" color="error">
                انصراف
              </Button>
            </div>
          </Box>
        </Grid>
      </Grid>
    </FormProvider>
  );
}
